export const truncateToDecimals = (value, decimals = 2) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return 0
  const factor = 10 ** decimals
  return Math.trunc(n * factor) / factor
}

const euroToCents = (euro) =>
  Math.trunc(truncateToDecimals(euro, 2) * 100 + 1e-8)

export const formatTruncatedNumber = (value) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return '0.00'
  const sign = n < 0 ? '-' : ''
  const cents = Math.abs(euroToCents(n))
  const intPart = Math.floor(cents / 100)
  const frac = String(cents % 100).padStart(2, '0')
  return `${sign}${intPart}.${frac}`
}

export const formatMoney = (value) => `${formatTruncatedNumber(value)}€`

export const getItemIvaRate = (item) => {
  const rawIva = item?.IVACP ?? item?.IVA ?? 0
  const normalized = Number(rawIva)
  return Number.isFinite(normalized) ? normalized : 0
}

export const grossToNet = (amount, iva) => {
  const n = Number(amount)
  if (!Number.isFinite(n)) return 0
  const divisor = 1 + (Number(iva) || 0) / 100
  return divisor > 0 ? n / divisor : n
}

/** Unit price shown in the Price column (truncated gross or net). */
export const getLinePrice = (item, pricesIncludeIva = true) => {
  const raw = Number(item?.marketPriceCP) || 0
  const rate = getItemIvaRate(item)
  if (pricesIncludeIva || rate === 0) {
    return truncateToDecimals(raw, 2)
  }
  return truncateToDecimals(grossToNet(raw, rate), 2)
}

/** Line total = trunc(PRECIO) × trunc(Cantidad) like a calculator (fixed-point). */
export const getLineTotalFromUnitPrice = (unitPrice, quantity) => {
  const truncatedUnitPrice = truncateToDecimals(unitPrice, 2)
  const truncatedQuantity = truncateToDecimals(quantity ?? 0, 2)
  const unitCents = euroToCents(truncatedUnitPrice)
  const qtyHundredths = Math.trunc(truncatedQuantity * 100 + 1e-8)
  const totalCents = Math.trunc((unitCents * qtyHundredths) / 100 + 1e-8)
  return totalCents / 100
}

export const formatLineTotalEuro = (item, pricesIncludeIva = true) => {
  const truncatedUnitPrice = truncateToDecimals(
    getLinePrice(item, pricesIncludeIva),
    2,
  )
  const truncatedQuantity = truncateToDecimals(item?.quantity ?? 0, 2)
  const unitCents = euroToCents(truncatedUnitPrice)
  const qtyHundredths = Math.trunc(truncatedQuantity * 100 + 1e-8)
  const totalCents = Math.trunc((unitCents * qtyHundredths) / 100 + 1e-8)
  const sign = totalCents < 0 ? '-' : ''
  const abs = Math.abs(totalCents)
  const intPart = Math.floor(abs / 100)
  const frac = String(abs % 100).padStart(2, '0')
  return `${sign}${intPart}.${frac}€`
}

export const getLineTotal = (item, pricesIncludeIva = true) =>
  getLineTotalFromUnitPrice(getLinePrice(item, pricesIncludeIva), item?.quantity)

/** Base imponible = Cantidad × unit price sin IVA (matches albarán BASE IMPONIBLE rows). */
export const getLineBaseImponible = (item, pricesIncludeIva = true) => {
  const rate = Number(item?.IVACP ?? item?.IVA ?? 0) || 0
  if (pricesIncludeIva) {
    return truncateToDecimals(
      getLineTotal(item, true) / (1 + rate / 100),
      2,
    )
  }
  return getLineTotal(item, false)
}
